module.exports = __webpack_public_path__ + "img/c01_buildingtechagogediscipline_Normal_ua.21e0f804.webp";